import { chartKeys } from 'utils/constant';

const key_statistics = {
  chartTitle: 'Key Statistics',
  chartKey: chartKeys.KEY_STATISTICs,
}

export default key_statistics;